import cn from 'classnames'
import styles from './GenericIcon.module.scss'

const GenericIcon = ({ src, alt, className }) => {
  return <img src={src} alt={alt} className={cn([className, styles.genericIcon])} />
}

export default GenericIcon
